import { CommonMessage } from '@frontend/lang';
import { UserSelectV2 } from '@frontend/user/select';
import { LuCircleAlert, LuNfc } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { useLinkBadge } from './link-badge.controller';

const ID = 'link-badge';

const LinkBadge = () => {
    const viewProps = useLinkBadge();

    if (viewProps.badgeLinked) {
        return (
            <WizardScreenContainer
                id={ID}
                footer={{
                    onBack: viewProps.onBack
                }}
                containerClassName='bg-background-default flex flex-1 flex-col items-center justify-center gap-4 self-stretch p-6'>
                <LuCircleAlert className='text-danger size-16' />
                <div className='text-always-black text-lg font-medium'>
                    <FormattedMessage
                        id='kiosk.wizard.link-badge.already-linked-title'
                        defaultMessage='Badge already linked'
                    />
                </div>
                <div className='text-foreground-secondary text-center text-sm'>
                    <FormattedMessage
                        id='kiosk.wizard.link-badge.already-linked'
                        defaultMessage='This badge is already linked to a user.'
                    />
                </div>
            </WizardScreenContainer>
        );
    }

    return (
        <WizardScreenContainer
            id={ID}
            loadingModal={{ show: viewProps.isLinking }}
            errorModal={{
                show: !!viewProps.error,
                title: CommonMessage.ERRORS.DEFAULT,
                message: viewProps.error,
                onClose: viewProps.resetError
            }}
            footer={{
                onBack: viewProps.onBack,
                onSubmit: viewProps.onConfirm,
                submitDisabled: !viewProps.selectedUser || viewProps.isLinking || !!viewProps.error,
                submitLabel: CommonMessage.BUTTONS.CONFIRM
            }}
            containerClassName='bg-background-default flex flex-1 flex-col items-center justify-start gap-4 self-stretch overflow-y-scroll p-6'>
            <div className='inline-flex items-center justify-center gap-3 self-stretch'>
                <LuNfc className='text-always-black size-6' />
                <div className='text-always-black text-lg font-medium'>
                    <FormattedMessage
                        id='kiosk.wizard.link-badge.heading'
                        defaultMessage='Select a user'
                    />
                </div>
            </div>

            <div className='text-foreground-secondary self-stretch text-center text-sm'>
                <FormattedMessage
                    id='kiosk.wizard.link-badge.description'
                    defaultMessage='Select the user to link this badge to.'
                />
            </div>
            <div className='w-full'>
                <UserSelectV2
                    id='link-badge'
                    isClearable
                    value={viewProps.selectedUser?.id ?? null}
                    onChangeObject={viewProps.onSelectUser}
                    minSearchCharacters={3}
                />
            </div>
        </WizardScreenContainer>
    );
};

export default LinkBadge;
